var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 191,
    viewBox: "0 0 184 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3597_9570)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.513 96.4962C179.513 144.186 140.195 182.796 91.7201 182.796C43.3178 182.796 4 144.186 4 96.4962C4 48.806 43.3178 10.1963 91.7201 10.1963C140.195 10.1963 179.513 48.806 179.513 96.4962Z",
    fill: "#E18A04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.877 87.9021C179.877 136.478 140.478 175.877 91.9021 175.877C43.3994 175.877 4 136.478 4 87.9021C4 39.3994 43.3994 0 91.9021 0C140.478 0 179.877 39.3994 179.877 87.9021Z",
    fill: "#FEB74D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.877 92.6355C179.877 141.211 140.478 180.538 91.9021 180.538C43.3994 180.538 4 141.211 4 92.6355C4 44.06 43.3994 4.7334 91.9021 4.7334C140.478 4.7334 179.877 44.06 179.877 92.6355ZM169.244 92.6355C169.244 49.9589 134.652 15.2933 91.9021 15.2933C49.2255 15.2933 14.6327 49.9589 14.6327 92.6355C14.6327 135.312 49.2255 169.905 91.9021 169.905C134.652 169.905 169.244 135.312 169.244 92.6355Z",
    fill: "#E18A04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.877 87.9021C179.877 136.478 140.478 175.877 91.9021 175.877C43.3994 175.877 4 136.478 4 87.9021C4 39.3994 43.3994 0 91.9021 0C140.478 0 179.877 39.3994 179.877 87.9021ZM169.244 87.9021C169.244 45.2255 134.652 10.6327 91.9021 10.6327C49.2255 10.6327 14.6327 45.2255 14.6327 87.9021C14.6327 130.652 49.2255 165.244 91.9021 165.244C134.652 165.244 169.244 130.652 169.244 87.9021Z",
    fill: "url(#paint0_linear_3597_9570)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9025 87.9021C124.456 87.9021 152.859 70.278 168.079 43.9875C152.859 17.6969 124.456 0 91.9025 0C59.4217 0 31.0192 17.6969 15.7983 43.9875C31.0192 70.278 59.4217 87.9021 91.9025 87.9021Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.556 107.578C77.4383 113.083 75.3241 118.585 73.2065 124.09C71.2484 129.184 66.3532 132.543 60.8976 132.543C51.3911 132.543 45.0061 122.785 48.8158 114.073L74.5331 55.2427C76.6331 50.4397 81.3757 47.3359 86.6149 47.3359H97.6006C102.84 47.3359 107.586 50.4397 109.682 55.2427L135.4 114.073C139.209 122.785 132.824 132.543 123.318 132.543H122.832C117.376 132.543 112.481 129.184 110.523 124.09L104.174 107.578C99.8389 96.3087 83.8906 96.3087 79.556 107.578Z",
    fill: "#E18A04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4844 107.268C87.5799 108.687 86.012 109.542 84.3377 109.542H78.1975C74.1572 109.542 71.8338 104.952 74.2246 101.692L81.0636 92.3559C81.429 91.8558 81.6915 91.306 81.844 90.7349C81.9859 90.2134 81.9859 89.653 81.844 89.1315C81.6879 88.5604 81.429 88.0106 81.0636 87.5104L74.2246 78.1777C71.8338 74.9179 74.1572 70.3278 78.1975 70.3278H84.3377C86.012 70.3278 87.5799 71.1826 88.4844 72.6015C90.3644 75.5315 94.6104 75.6379 96.6465 72.8144L96.9516 72.3781C97.881 71.0904 99.3743 70.3242 100.956 70.3242H106.022C110.101 70.3242 112.417 75.003 109.938 78.2451L103.386 86.8258C102.687 87.7375 102.35 88.8371 102.386 89.9296C102.354 91.0222 102.691 92.1218 103.386 93.0334L109.938 101.614C112.417 104.856 110.101 109.535 106.022 109.535H100.956C99.3708 109.535 97.8774 108.772 96.9516 107.481L96.6465 107.045C94.6104 104.221 90.3644 104.328 88.4844 107.258V107.268Z",
    fill: "#E18A04"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.556 103.938C77.4383 109.443 75.3241 114.945 73.2065 120.45C71.2484 125.544 66.3532 128.903 60.8976 128.903C51.3911 128.903 45.0061 119.144 48.8158 110.433L74.5331 51.602C76.6331 46.7991 81.3757 43.6953 86.6149 43.6953H97.6006C102.84 43.6953 107.586 46.7991 109.682 51.602L135.4 110.433C139.209 119.144 132.824 128.903 123.318 128.903H122.832C117.376 128.903 112.481 125.544 110.523 120.45L104.174 103.938C99.8389 92.6681 83.8906 92.6681 79.556 103.938Z",
    fill: "url(#paint1_linear_3597_9570)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4844 103.628C87.5799 105.047 86.012 105.902 84.3377 105.902H78.1975C74.1572 105.902 71.8338 101.311 74.2246 98.0516L81.0636 88.7153C81.429 88.2152 81.6915 87.6653 81.844 87.0942C81.9859 86.5728 81.9859 86.0123 81.844 85.4909C81.6879 84.9198 81.429 84.37 81.0636 83.8698L74.2246 74.5371C71.8338 71.2772 74.1572 66.6871 78.1975 66.6871H84.3377C86.012 66.6871 87.5799 67.542 88.4844 68.9609C90.3644 71.8909 94.6104 71.9973 96.6465 69.1737L96.9516 68.7374C97.881 67.4498 99.3743 66.6836 100.956 66.6836H106.022C110.101 66.6836 112.417 71.3624 109.938 74.6045L103.386 83.1852C102.687 84.0968 102.35 85.1965 102.386 86.289C102.354 87.3816 102.691 88.4812 103.386 89.3928L109.938 97.9735C112.417 101.216 110.101 105.894 106.022 105.894H100.956C99.3708 105.894 97.8774 105.132 96.9516 103.841L96.6465 103.404C94.6104 100.581 90.3644 100.687 88.4844 103.617V103.628Z",
    fill: "#FEB74D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3597_9570",
    x: 0,
    y: 0,
    width: 183.877,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3597_9570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3597_9570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3597_9570",
    x1: -25656.5,
    y1: 104752,
    x2: 584.403,
    y2: 54011.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB74D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3597_9570",
    x1: -12911.4,
    y1: 50793.3,
    x2: -507.098,
    y2: 25790.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB74D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.b971be5b46b5aaf7ab76690f1d6297de.svg";
export { ForwardRef as ReactComponent };